import style from "./account.module.scss";
import AccountProfile from "./AccountProfile";
import Card from "./Card";
import AccountMenu from "./AccountMenu";
import Logout from "./Logout";
import useAuth, { TYPE_USER, TYPE_INSTITUTION } from "../../hooks/useAuth";
import toTitleCase from "../../utils/toTitleCase";
import { useMsal } from "@azure/msal-react";
import { passwordResetRequest } from "../../authConfig";

const determineProfileName = (authDetails) => {
  if (authDetails?.type === TYPE_USER) {
    return `${authDetails.givenName} ${authDetails.familyName || ""}`.trim();
  } else if (authDetails?.type === TYPE_INSTITUTION) {
    return  toTitleCase(authDetails.institutionName);
  }
  return "" ;
};

const determineEmail = (authDetails) => authDetails?.email;

const AccountForLoggedInUser = () => {
  const { authDetails } = useAuth();
  const { instance, accounts } = useMsal();
  const profileName = determineProfileName(authDetails);
  const email = determineEmail(authDetails);

  const handlePasswordReset = () => {
    if (!accounts[0]) {
      console.error("No active account found");
      return;
    }

    instance.loginRedirect(passwordResetRequest).catch((e) => {
      console.error(e);
    });
  };

  return (
    <div className={style.loginItems}>
      {authDetails && <AccountProfile name={profileName} email={email} isEmailVisible={authDetails.type === TYPE_USER} />}
      <div className={style.cardRow}>
        <Card
          name="My favourites"
          route="/app/favourites"
          iconname="Favourite"
        />
        <Card name="Saved search" route="/app/savedSearch" iconname="Saved" />
      </div>
      <div className={style.menuList}>
        <AccountMenu name="Change password" onClickFuc={handlePasswordReset} />
        <AccountMenu name="Subscriptions" route="/app/accountSubscription" />
        <AccountMenu
          name="What’s New"
          route="https://www.tg.org.au/products/therapeutic-guidelines/updates/"
          isExternal={true}
        />
        <AccountMenu
          name="About us & Legal"
          route="/app/aboutUsAndLegal"
          isExternal={false}
        />
      </div>
      <div className={style.cardRow}>
        <p>
          We welcome feedback from our community; please contact{" "}
          <a className={style.underline} href="mailto:feedback@tg.org.au">
            feedback@tg.org.au
          </a>
          .
        </p>
      </div>
      <Logout />
    </div>
  );
};

export default AccountForLoggedInUser;
